module.exports = __webpack_public_path__ + "img/uvlek-mob.27d2c071.png";